import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
// import moment from "moment"
import { format } from "date-fns";
import { connect } from "react-redux";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import Pagination from "../../../layout/Pagination";
import { string_uppercase } from "../../../../utilities/_string_uppercase";

import OutletCallLocation from "./components/outletLocation";
import LoadingCard from "./components/loading";
// import KYCHistoryCard from "./components/kycHistoryCard";

import image_not_found_img from "./../../../../img/image-not-found.png";
import mdo_img from "./../../../../img/calls_card/mdo.svg";
import phone_img from "./../../../../img/calls_card/phone.svg";
import event_img from "./../../../../img/calls_card/event.svg";
import bmcc_img from "./../../../../img/calls_card/bmcc.svg";
import spot_img from "./../../../../img/calls_card/spot.svg";

import lead_closed_img from "./../../../../img/calls_card/lead_closed.svg";
import lead_generated_img from "./../../../../img/calls_card/lead_generated.svg";
import existing_merchant_served_img from "./../../../../img/calls_card/existing_merchant_served.svg";
import lead_followed_up_img from "./../../../../img/calls_card/lead_followed_up_img.svg";

import lead_closed__card_corner_img from "./../../../../img/calls_card/lead_closed_card_corner.svg";
import lead_generated__card_corner_img from "./../../../../img/calls_card/lead_generated_card_corner.svg";
import existing_merchant_served__card_corner_img from "./../../../../img/calls_card/existing_merchant_served_card_corner.svg";
import lead_followed_up__card_corner_img from "./../../../../img/calls_card/lead_followed_up_card_corner_img.svg";

import "./style.scss";
import Footer from "../../../Footer/Footer";

class KAMOutletsDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      outlet_basic_info: null,
      outlet_calls_history: null,
      outlet_total_calls: null,
      outlet_calls_limit: null,
      outlet_kyc_history: null,

      data_fetching: false,
      kyc_fetching: false,
    };
  }

  componentDidMount() {
    this.set_outlet_basic_info();
    this.set_outlet_calls_history();
    // this.set_outlets_kyc_history();
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.currentPage !== prevProps.currentPage ||
      this.props.currentLimit !== prevProps.currentLimit
    )
      this.set_outlet_calls_history();
  }

  set_outlet_basic_info() {
    axios
      .get(
        `${process.env.REACT_APP_KAM_API_URL}outlets/v1/${this.props.match.params.id}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return this.setState({
          outlet_basic_info: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  set_outlet_calls_history() {
    this.setState({
      data_fetching: true,
    });

    axios
      .get(
        `${process.env.REACT_APP_KAM_API_URL}outlets/v1/${this.props.match.params.id}/calls?page_index=${this.props.currentPage}&page_size=${this.props.currentLimit}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        return this.setState({
          outlet_calls_history: res.data.data,
          outlet_total_calls: res.data.count,
          outlet_calls_limit: res.data.limit,

          data_fetching: false,
        });
      })
      .catch(() =>
        this.setState({
          data_fetching: false,
        })
      );
  }

  // set_outlets_kyc_history() {
  //   this.setState({ kyc_fetching: true });

  //   axios
  //     .get(
  //       `${process.env.REACT_APP_KAM_API_URL}/api/outlets/v1/${this.props.match.params.id}/kyc-history`,
  //       {
  //         headers: {
  //           Authorization:
  //             "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       return this.setState({
  //         outlet_kyc_history: res.data,
  //         kyc_fetching: false,
  //       });
  //     })
  //     .catch(() => this.setState({ kyc_fetching: false }));
  // }

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    return (
      <div className="main-container">
        <div className="outlet-detail-container">
          {this.state.outlet_basic_info && (
            <div className="row">
              <div className="col l6 s12">
                <div className="outlet-section section-left">
                  <Zoom>
                    <img
                      src={
                        this.state.outlet_basic_info.image ||
                        image_not_found_img
                      }
                      // width="500px"
                      alt="outlet"
                    />
                  </Zoom>
                  <div className="outlet-description outlet-description--right">
                    <span className="outlet-name">
                      {string_uppercase(
                        this.state.outlet_basic_info.brand_name
                      )}
                    </span>
                    <div className="outlet-phone">
                      {this.state.outlet_basic_info.wallet_no ? (
                        <>
                          <div className="value">
                            {this.state.outlet_basic_info.wallet_no}
                          </div>
                          <div className="tag">Merchant Wallet Number</div>
                        </>
                      ) : (
                        <>
                          <div className="value">
                            {
                              this.state.outlet_basic_info
                                .contact_person_phone_number
                            }
                          </div>
                          <div className="tag">Merchant Contact Number</div>
                        </>
                      )}
                    </div>
                    <span
                      className={
                        // this.state.outlet_basic_info.outlet_type.toUpperCase() ===
                        // "MICRO MERCHANT"
                        //   ? "blue-type"
                        //   : this.state.outlet_basic_info.outlet_type.toUpperCase() ===
                        //     "MERCHANT PLUS LITE B"
                        //   ? "navy-blue-type"
                        //   : this.state.outlet_basic_info.outlet_type.toUpperCase() ===
                        //     "MERCHANT PLUS LITE A"
                        //   ? "purpple-type"
                        //   : this.state.outlet_basic_info.outlet_type.toUpperCase() ===
                        //     "MEDIUM MERCHANT"
                        //   ? "olive-type"
                        //   : "green-type"
                        "green-type"
                      }
                    >
                      {/* {string_uppercase(
                        this.state.outlet_basic_info.outlet_type
                      )} */}
                      Merchant Plus
                    </span>

                    <div className="outlet-call__mdo">
                      <div className="call">
                        <div className="value">
                          {this.state.outlet_basic_info.call_count}
                        </div>
                        <div className="tag">Total Calls To This Outlet</div>
                      </div>
                      <div className="mdo">
                        <div className="value">
                          {this.state.outlet_basic_info.mdo_count}
                        </div>
                        <div className="tag">MDOs Covered This Outlet</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col l6 s12">
                <div className="outlet-section section-right">
                  <div className="outlet-description outlet-description--left">
                    <div className="info">
                      <img src={event_img} alt="bmcc img" />
                      <div className="data">
                        Last Visit Date & Time
                        <span>
                          {this.state.outlet_basic_info.last_visit_time
                            ? // ? moment(
                              //     this.state.outlet_basic_info.last_visit_time
                              //   ).format("llll")
                              format(
                                new Date(
                                  this.state.outlet_basic_info.last_visit_time
                                ),
                                "EEE, MMM d yyyy h:mm a"
                              )
                            : "..."}
                        </span>
                      </div>
                    </div>

                    <div className="info">
                      <img src={bmcc_img} alt="bmcc img" />
                      <div className="data">
                        <span>
                          {this.state.outlet_basic_info.bmcc__code || "..."}
                        </span>
                        <span className="code-description bmcc-code-description">
                          {this.state.outlet_basic_info.bmcc__name || "..."}
                        </span>
                      </div>
                    </div>

                    <div className="info">
                      <img src={spot_img} alt="bmcc img" />
                      <div className="data">
                        <span>
                          {this.state.outlet_basic_info.cluster_code__code ||
                            "..."}
                        </span>
                        <span className="code-description">
                          {this.state.outlet_basic_info.cluster_code__name ||
                            "..."}
                        </span>
                      </div>
                    </div>
                  </div>
                  {this.state.outlet_basic_info.lat &&
                    this.state.outlet_basic_info.lng && (
                      <OutletCallLocation
                        location={[
                          this.state.outlet_basic_info.lat,
                          this.state.outlet_basic_info.lng,
                        ]}
                      />
                    )}
                </div>
              </div>
            </div>
          )}

          <div className="page-header">
            <div className="page-heading">
              Call History
              <div className="page-sub-heading">
                {this.state.outlet_total_calls} Calls Till Date
              </div>
            </div>
          </div>

          <Pagination
            page={"outlet_detail"}
            currentPage={this.props.currentPage}
            total={this.state.outlet_total_calls}
            limit={this.props.currentLimit}
          />

          <div className="outlet-call-cards">
            {this.state.data_fetching ? (
              <LoadingCard
              // card_heading={`${item.card_heading}`}
              />
            ) : (
              <div className="card-row row">
                {this.state.outlet_calls_history &&
                  this.state.outlet_calls_history.map((item, index) => (
                    <div className="card-col col l4 m6 s12">
                      <div className="card call-card" key={this.props.index}>
                        <img
                          className="img card-corner"
                          src={
                            item.call_outcome.toUpperCase() ===
                            "EXISTING MERCHANT SERVED"
                              ? existing_merchant_served__card_corner_img
                              : item.call_outcome.toUpperCase() ===
                                "LEAD GENERATED"
                              ? lead_generated__card_corner_img
                              : item.call_outcome.toUpperCase() ===
                                "LEAD FOLLOWED-UP"
                              ? lead_followed_up__card_corner_img
                              : lead_closed__card_corner_img
                          }
                          alt="card-corner"
                        />
                        <div className="row header">
                          <div className="col s12 l12">
                            <img
                              src={
                                item.call_outcome.toUpperCase() ===
                                "EXISTING MERCHANT SERVED"
                                  ? existing_merchant_served_img
                                  : item.call_outcome.toUpperCase() ===
                                    "LEAD GENERATED"
                                  ? lead_generated_img
                                  : item.call_outcome.toUpperCase() ===
                                    "LEAD FOLLOWED-UP"
                                  ? lead_followed_up_img
                                  : lead_closed_img
                              }
                              alt="outlet"
                            />

                            <div className="call-info">
                              Call Outcome
                              <span
                                className={
                                  item.call_outcome.toUpperCase() ===
                                  "EXISTING MERCHANT SERVED"
                                    ? "existing_merchant_served_info"
                                    : item.call_outcome.toUpperCase() ===
                                      "LEAD GENERATED"
                                    ? "lead_generated_info"
                                    : item.call_outcome.toUpperCase() ===
                                      "LEAD FOLLOWED-UP"
                                    ? "lead_followed_up_info"
                                    : "lead_closed_info"
                                }
                              >
                                {string_uppercase(item.call_outcome) || "..."}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col s12 l6">
                            <img src={mdo_img} alt="mdo img" />
                            <div className="call-info">
                              Assigned KAM Name
                              <span className="name">
                                {string_uppercase(
                                  item.outlet__assigned_kam__name
                                ) || "..."}
                              </span>
                            </div>
                          </div>

                          <div className="col s12 l6">
                            <img src={phone_img} alt="phone img" />
                            <div className="call-info">
                              KAM Phone
                              <span>
                                {item.outlet__assigned_kam__whitelisting_number}
                              </span>
                            </div>
                          </div>

                          <div className="col s12 l6">
                            <img src={event_img} alt="event img" />
                            <div className="call-info">
                              Call Date & Time
                              <span>
                                {/* {moment(item.zone_aware_created).format("llll")} */}
                                {format(
                                  new Date(item.zone_aware_created),
                                  "EEE, MMM d yyyy h:mm a"
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="col s12 l6">
                            <img src={spot_img} alt="spot img" />
                            <div className="call-info">
                              Cluster Code
                              <span>
                                {item.outlet__cluster_code__code || "..."}
                              </span>
                              <span className="code-description">
                                {item.outlet__cluster_code__name || "..."}
                              </span>
                            </div>
                          </div>
                          <div className="col s12 l6">
                            <img src={bmcc_img} alt="bmcc img" />
                            <div className="call-info">
                              BMCC Code
                              <span>{item.outlet__bmcc__code || "..."}</span>
                              <span className="code-description bmcc-code-description">
                                {item.outlet__bmcc__name || "..."}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>

          <Pagination
            page={"outlet_detail"}
            currentPage={this.props.currentPage}
            total={this.state.outlet_total_calls}
            limit={this.props.currentLimit}
          />
        </div>
        {/* <div className="kyc-history-card-container">
          {this.state.kyc_fetching ? (
            <LoadingCard
            // card_heading={`${item.card_heading}`}
            />
          ) : (
            <>
              <div className="kyc-heading">
                <div className="kyc-headline">KYC History</div>
                <div className="kyc-sub-headline">Activity Summary</div>
              </div>
              <div className="card-row row kyc-history-cards">
                {this.state.outlet_kyc_history &&
                  this.state.outlet_kyc_history.map((item, index) => (
                    <div className="card-col col l12 s12 m12">
                      <KYCHistoryCard history={item} key={index} />
                    </div>
                  ))}
              </div>
            </>
          )}
        </div> */}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let currentPage = state.page.outlet_detail
    ? state.page.outlet_detail.currentPage
    : state.page.default.currentPage;

  let currentLimit = state.paginationLimit.outlet_detail
    ? state.paginationLimit.outlet_detail.currentLimit
    : 12;
  return { currentPage, currentLimit };
};

export default connect(mapStateToProps, null)(KAMOutletsDetail);
